import {AsyncPipe} from '@angular/common';
import {Component, Inject, OnInit} from '@angular/core';
import {MAT_BOTTOM_SHEET_DATA} from '@angular/material/bottom-sheet';
import {MatDivider} from '@angular/material/divider';

import {Asset, AssetType} from '@app/asset';
import {AuthService} from '@app/auth/auth.service';
import {User} from '@app/shared/user.service';

import {Observable, of} from 'rxjs';
import {ActionsInspectorComponent} from '../actions-inspector/actions-inspector.component';
import {AnnotationInspectorComponent} from '../annotation-inspector/annotation-inspector.component';
import {AssetInspectorComponent} from '../asset-inspector/asset-inspector.component';
import {AuthorInspectorComponent} from '../author-inspector/author-inspector.component';
import {GroupInspectorComponent} from '../group-inspector/group-inspector.component';
import {InspectorService} from '../inspector.service';
import {TagInspectorComponent} from '../tag-inspector/tag-inspector.component';
import {ThumbnailInspectorComponent} from '../thumbnail-inspector/thumbnail-inspector.component';

@Component({
    selector: 'frog-inspector',
    templateUrl: './inspector.component.html',
    styleUrls: ['./inspector.component.scss'],
    imports: [
        ThumbnailInspectorComponent,
        MatDivider,
        GroupInspectorComponent,
        AuthorInspectorComponent,
        AssetInspectorComponent,
        ActionsInspectorComponent,
        TagInspectorComponent,
        AnnotationInspectorComponent,
        AsyncPipe,
    ],
})
export class InspectorComponent implements OnInit {
    public asset$: Observable<Asset>;
    public user$: Observable<User>;
    public AssetType = AssetType;

    constructor(
        private inspectorService: InspectorService,
        private authService: AuthService,
        @Inject(MAT_BOTTOM_SHEET_DATA) public data: Asset = null,
    ) {}

    ngOnInit(): void {
        if (Object.keys(this.data).length) {
            this.asset$ = of(this.data);
        } else {
            this.asset$ = this.inspectorService.asset;
        }
        this.user$ = this.authService.user;
    }
}
